<template>
  <el-dialog title="选择客户" :visible.sync="visibleInner" width="800px" append-to-body @close="handleClose">
    <el-form :inline="true" :model="query">
      <el-form-item label="客户编码"><el-input v-model="query.customerCode" size="small" clearable /></el-form-item>
      <el-form-item label="客户名称"><el-input v-model="query.customerName" size="small" clearable /></el-form-item>
      <el-form-item><el-button size="small" type="primary" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" height="400">
      <el-table-column prop="customerCode" label="客户编码" width="130" />
      <el-table-column prop="customerName" label="客户名称" min-width="160" />
      <el-table-column prop="contactPerson" label="联系人" width="100" />
      <el-table-column prop="phone" label="联系电话" width="120" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="pageChange"
    />
  </el-dialog>
</template>

<script>
import { listCustomer } from '../api/sale/customer'

export default {
  name: 'CustomerSelector',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      visibleInner: false,
      query: { customerCode: '', customerName: '' },
      list: [],
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.visibleInner = !!val
        if (val) {
          this.pageIndex = 1
          this.loadList()
        }
      }
    }
  },
  methods: {
    search() {
      this.pageIndex = 1
      this.loadList()
    },
    loadList() {
      this.loading = true
      listCustomer({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        customerCode: this.query.customerCode,
        customerName: this.query.customerName,
        isenabled: '0'
      }).then(res => {
        this.loading = false
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => {
        this.loading = false
      })
    },
    pageChange(val) {
      this.pageIndex = val
      this.loadList()
    },
    choose(row) {
      this.$emit('select', row)
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
